import React from "react";
import "./Email.css";

export default function Email() {
  return (
    <>
      <div className="truck">
        <h2 className="truck-title">Do You Want To Check Your Health,?</h2>
        <div className="truck-input">
          <div className="box-input">
            <p>Your Email..</p>
            <button>Sending</button>
          </div>
        </div>
      </div>
    </>
  );
}
